<template>
  <div class="pt-32 pb-20 px-6 max-w-4xl mx-auto">
    <div class="glass-card p-8 md:p-12 rounded-3xl border border-fire-gold/20 relative overflow-hidden">
      <!-- Glow effect -->
      <div class="absolute -top-24 -right-24 w-48 h-48 bg-fire-gold/10 blur-3xl rounded-full"></div>
      
      <h1 class="text-4xl md:text-5xl font-black mb-8 bg-gradient-to-r from-fire-gold via-white to-fire-gold bg-clip-text text-transparent italic">
        CONDITIONS GÉNÉRALES DE VENTE
      </h1>

      <div class="space-y-8 text-gray-300 leading-relaxed">
        <section class="border-b border-white/5 pb-6">
          <p class="text-sm uppercase tracking-widest text-fire-gold mb-2">Identification</p>
          <p>
            Entre la société <strong>BEST ARTIFICE SAS</strong>, 53 rue de l’Université, 69007 Lyon, au capital social de 5 000 €, 
            immatriculée au Registre du Commerce et des Sociétés de LYON sous le numéro SIRET 818 554 370 00036, 
            représentée par M. SEBAA en qualité de gérant, dûment habilité aux fins des présentes.
          </p>
          <p class="mt-4">
            La société peut être contactée par e-mail via le formulaire de contact accessible depuis la page d’accueil du site.
          </p>
          <p class="mt-2 italic">Ci-après dénommée le « Vendeur » ou la « Société ».</p>
        </section>

        <section v-for="(article, index) in articles" :key="index">
          <h2 class="text-xl font-bold text-white mb-4 flex items-center">
            <span class="text-fire-gold mr-3">Article {{ article.id }} :</span>
            {{ article.title }}
          </h2>
          <div v-html="article.content" class="text-gray-400 space-y-4"></div>
        </section>

        <section class="mt-12 p-6 rounded-2xl bg-white/5 border border-white/10">
          <h2 class="text-xl font-bold text-white mb-4 italic">Contact & Support</h2>
          <p>Pour toute question relative à ces conditions, vous pouvez nous contacter :</p>
          <ul class="mt-4 space-y-2 text-fire-gold">
            <li>📞 Téléphone : 07 69 00 08 08</li>
            <li>📧 Email : <a href="mailto:contact@authentiqueartifice.com" class="hover:underline">contact@authentiqueartifice.com</a></li>
            <li>📍 Boutique : 53 rue de l’université 69007 Lyon</li>
          </ul>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
const articles = [
  {
    id: 1,
    title: "Objet",
    content: "<p>Les présentes Conditions Générales de Vente déterminent les droits et obligations des parties dans le cadre de la vente en ligne de Produits ou Services proposés par le Vendeur.</p>"
  },
  {
    id: 2,
    title: "Dispositions générales",
    content: `<p>Les présentes Conditions Générales de Vente (CGV) régissent les ventes de Produits ou de Services effectuées via les sites internet de la Société et font partie intégrante du Contrat conclu entre l’Acheteur et le Vendeur. Elles s’imposent pleinement à l’Acheteur, qui les a acceptées avant de passer commande.</p>
              <p>Le Vendeur se réserve le droit de modifier les présentes conditions à tout moment en publiant une nouvelle version sur son site internet. Les CGV applicables sont celles en vigueur à la date du paiement de la commande. Elles peuvent être consultées à l'adresse : <span class="text-fire-gold">authentiqueartifice.com/conditions-generales</span>.</p>`
  },
  {
    id: 3,
    title: "Prix",
    content: `<p>Les prix des produits vendus sont indiqués en Euros hors taxes sur les pages de descriptifs. Ils sont indiqués toutes taxes comprises (TVA incluse) sur la page de commande, hors frais spécifiques d’expédition. Des droits de douane ou autres taxes locales sont susceptibles d’être exigés pour les livraisons hors France continentale et restent à la charge exclusive de l'acheteur.</p>`
  },
  {
    id: 4,
    title: "Conclusion du contrat en ligne",
    content: `<p>Conformément aux dispositions de l’article 1127-1 du Code civil, le Client doit suivre une série d’étapes pour conclure le contrat : Information produit, choix des options, coordonnées, acceptation des CGV, vérification du détail (double clic) et confirmation du paiement.</p>`
  },
  {
    id: 5,
    title: "Produits et services",
    content: `<p>Les caractéristiques essentielles des biens et leurs prix respectifs sont mis à disposition sur le site. Le Vendeur s’engage à honorer la commande dans la limite des stocks disponibles uniquement. À défaut, le Vendeur en informe le Client et procède au remboursement ou propose un produit de substitution.</p>`
  },
  {
    id: 6,
    title: "Conformité",
    content: `<p>Conformément à l’article L.411-1 du Code de la consommation, les produits répondent aux prescriptions relatives à la sécurité et à la santé. Le Vendeur rembourse ou échange les produits défectueux ou ne correspondant pas à la commande. Les demandes doivent être adressées à <span class="text-fire-gold">bestartifice@gmail.com</span>.</p>`
  },
  {
    id: 7,
    title: "Clause de réserve de propriété",
    content: "<p>Les produits demeurent la propriété de la Société jusqu’au complet paiement du prix.</p>"
  },
  {
    id: 8,
    title: "Modalités de livraison",
    content: `<p>Les produits sont livrés à l’adresse indiquée lors de la commande. Les délais indiqués ne prennent pas en compte le temps de préparation. En cas de retard significatif, le Client peut résoudre le contrat dans les conditions définies à l’Article L 138-2 du Code de la consommation.</p>`
  },
  {
    id: 9,
    title: "Paiement",
    content: `<p>Le paiement est exigible immédiatement à la commande. Le règlement s'effectue par carte bancaire via nos prestataires sécurisés (SumUp, Stripe). Les informations transmises sont chiffrées selon les règles de l’art.</p>`
  },
  {
    id: 10,
    title: "Droit de rétractation",
    content: `<p>Conformément à l’article L 221-5, l’Acheteur dispose d’un délai de quatorze (14) jours pour se rétracter sans motif. Les produits doivent être retournés dans leur état d’origine et complets. Les frais de retour sont à la charge du Client.</p>`
  },
  {
    id: 11,
    title: "Propriété intellectuelle",
    content: "<p>Les marques, noms de domaines, produits, images et vidéos restent la propriété exclusive du Vendeur. Toute reproduction totale ou partielle est strictement interdite.</p>"
  },
  {
    id: 12,
    title: "Protection des données personnelles",
    content: `<p>Conformément au RGPD, le Vendeur met en place un traitement destiné à la gestion des commandes. Le responsable du traitement est M. Seball. Le client dispose d'un droit d'accès, de rectification et de suppression de ses données personnelles sur simple demande.</p>`
  }
];
</script>

<style scoped>
.glass-card {
  background: rgba(10, 10, 15, 0.7);
  backdrop-filter: blur(20px);
}
</style>
